export default function getPageContext($event) {
  if ($event.target.closest('.product-recommendations')) return 'Recommended Products'
  let controller = document.body.getAttribute('data-controller')
  if (controller === 'product_groups') controller = 'products'
  return controller.charAt(0).toUpperCase() + controller.slice(1) + ' Page'
}
